<div mat-dialog-title>{{ 'Add_user' | translate }}</div>
<mat-dialog-content>
    <div class="container">
        <mat-form-field>
            <input matInput
                   type="text"
                   [formControl]="emailFormControl"
                   (keyup)="onEmailKeyup()"
                   placeholder="{{ searchPlaceholder | translate }}"
                   [matAutocomplete]="emailAutocomplete">
            <span *ngIf="!isSearchMode" matPrefix><mat-icon>mail_outline</mat-icon> &nbsp;</span>
            <span *ngIf="isSearchMode" matPrefix><mat-icon>search</mat-icon> &nbsp;</span>
            <mat-error *ngIf="emailFormControl.hasError('invalidEmail')">{{ 'Email_invalid' | translate }}</mat-error>
            <mat-error *ngIf="emailFormControl.hasError('isAdmin')">{{ 'Admin_users_cannot_be_added_to_projects' | translate }}</mat-error>
            <mat-error *ngIf="emailFormControl.hasError('alreadyMember')">{{ 'User_is_already_member' | translate }}</mat-error>
            <mat-error *ngIf="emailFormControl.hasError('unavailable')">{{ 'Email_unavailable' | translate }}</mat-error>
        </mat-form-field>
        <mat-autocomplete #emailAutocomplete="matAutocomplete"
                         [displayWith]="getUserEmail">
            <mat-option *ngFor="let user of filteredUsers | async"
                       [value]="user"
                       (onSelectionChange)="onOptionSelected($event, user)">
                <span class="option-legend">{{ user.firstName }} {{ user.lastName }}</span> ({{ user.email }})
            </mat-option>
        </mat-autocomplete>
    </div>
    <div class="container" [ngClass]="{ 'hidden': isSearchMode }">
        <mat-form-field>
            <input matInput
                   type="text"
                   [formControl]="firstNameFormControl"
                   placeholder="{{ 'First_name' | translate }}">
            <span matPrefix><mat-icon>perm_identity</mat-icon> &nbsp;</span>
            <mat-error *ngIf="firstNameFormControl.hasError('name')">{{ 'The_first_name_required' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field>
            <input matInput
                   type="text"
                   [formControl]="lastNameFormControl"
                   placeholder="{{ 'Last_name' | translate }}">
            <mat-error *ngIf="lastNameFormControl.hasError('name')">{{ 'The_last_name_required' | translate }}</mat-error>
        </mat-form-field>
    </div>
    <div class="container remark" [ngClass]="{ 'hidden': isSearchMode || selectedUser }">
        {{ 'A_new_user_will_be_created' | translate }}
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'Cancel' | translate}}</button>
    <button mat-raised-button
            (click)="onAddClicked()"
            color="accent"
            [disabled]="isLoading
                || isSearchMode
                || firstNameFormControl.invalid
                || lastNameFormControl.invalid
                || emailFormControl.invalid
                ? 'true' : null">
        {{ 'Add' | translate}}
    </button>
</mat-dialog-actions>
<div class="progress-container">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>
